import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 1,
  path: '/home',
  component: Home,
  redirect: '/home/index',
  name: 'home',
  isHead: true,
  meta: {
    title: '工作台',
    img: require('@/assets/img/gzt.png')
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/home/index'),
      name: 'Home',
      meta: { title: '工作台', close: false }
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/home.js